import React, { createContext } from 'react';
import firebase from 'firebase/app';

const config = {
  apiKey: 'AIzaSyBxnVJg9J8VTQoD9TZ_hcSX9id5qpnq684',
  authDomain: 'furlough-main.firebaseapp.com',
  databaseURL: 'https://furlough-main.firebaseio.com',
  projectId: 'furlough-main',
  storageBucket: 'furlough-main.appspot.com',
  messagingSenderId: '219435137626',
  appId: '1:219435137626:web:134dca7fda79c22e'
};

const app = firebase.initializeApp(config);

const firebaseContext = createContext();
const { Provider } = firebaseContext;
export default firebaseContext;

export function FirebaseProvider({ children }) {
  return <Provider value={app}>{children}</Provider>;
}
